/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_FACADE = '/checkout';
const RESOURCE_PAGE_FACADE = '/availability';
const RESOURCE_PAGE_ACTION = '/greeting';

const getGreetingDetails = (wcEnv, jwtToken, productCode, brandCode, zipCode, locationType, deliveryDate) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const resourcePage = `${RESOURCE_PAGE_FACADE}${RESOURCE_PAGE_ACTION}`;
    const params = {
        productCode,
        brandCode,
        zipCode,
        locationType,
        deliveryDate,
    };

    return restClient.getFacade(env, resourcePage, jwtToken, params)
        .then((response) => response);
};

export default getGreetingDetails;
